import React from "react";
import { Navigate } from "react-router-dom";
import {
  canRefreshExpiredPortalSession,
  hasValidPortalSession,
} from "../../utils/authSession";

export default function NewRouteGuard({ children }) {
  if (hasValidPortalSession()) {
    return children;
  }

  // The login page refreshes expired tokens. Keep its credentials until that
  // refresh has had a chance to run after a full-page reload.
  if (!canRefreshExpiredPortalSession()) {
    sessionStorage.clear();
  }
  return <Navigate to="/" replace />;
}
